import { TransactionStatus } from 'src/type/transaction';

export const txStatusLabel = (status: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.PENDING:
    case TransactionStatus.WAITING_TICKET:
      return 'รอดำเนินการ';
    case TransactionStatus.SUCCESS:
      return 'สำเร็จ';
    case TransactionStatus.REJECTED:
      return 'ปฏิเสธ';
    case TransactionStatus.CANCEL:
      return 'ยกเลิก';
    case TransactionStatus.WAITING:
      return 'รอราคา';
    default:
      return '';
  }
};
